export default [
  '$httpProvider',
  '$compileProvider',
  '$qProvider',
  function ($httpProvider, $compileProvider, $qProvider) {
    $httpProvider.useApplyAsync(true)
    $httpProvider.defaults.headers.common['xsrfCookieName'] = 'X-XSRF-Token'
    $httpProvider.interceptors.push(function () {
      return {
        response: function (res) {
          return res
        },
      }
    })
    $compileProvider.debugInfoEnabled(false)
    $compileProvider.aHrefSanitizationWhitelist(
      /^\s*(https?|ftp|mailto|file|sms|tel):/
    )

    // backward compatibility for ui router w/angular 1.6.0
    if (typeof $qProvider.errorOnUnhandledRejections === 'function') {
      $qProvider.errorOnUnhandledRejections(false)
    }

    // legacy support for controller binding assignment outside of $onInit()
    if (typeof $compileProvider.preAssignBindingsEnabled === 'function') {
      $compileProvider.preAssignBindingsEnabled(true)
    }
  },
]
